import React from 'react';

import RoundTextInput from '../../../../components/RoundTextInput';
import RoundTextArea from '../../../../components/RoundTextArea';
import Button from '../../../../components/Button';

import './Desktop.css';


const Component = ({
  updateName,
  updateEmail,
  updateMessage,
  submit,
  loading,
  error,
}) => (
  <div>
    <div className="contactForm_header">
      Contact
    </div>
    <div className="contactForm_inputContainer">
      <div className="contact_error">
        { error }
      </div>
      <RoundTextInput placeholder="Name"
                      onChange={updateName}
      />
      <RoundTextInput placeholder="Email"
                      onChange={updateEmail}
      />
      <RoundTextArea placeholder="Message"
                     onChange={updateMessage}
      />
    </div>
    <Button onClick={submit} loading={loading}>
      Send
    </Button>
  </div>
);

Component.displayName = "Desktop";

export default Component;



// WEBPACK FOOTER //
// ./src/forms/Contact/components/Contact/Desktop.js